import { createRouter, createWebHistory } from 'vue-router'

/** Public pages **/
import HomePage from '@/pages/HomePage.vue'
import ApplyPage from '@/pages/ApplyPage.vue'
import AboutPage from '@/pages/AboutPage.vue'
import PaymentPage from '@/pages/PaymentPage.vue'
import ContactPage from '@/pages/ContactPage.vue'
import LoginPage from '@/pages/LoginPage.vue'
import ForgotPasswordPage from '@/pages/ForgotPasswordPage.vue'
import FormSubmitted from '@/pages/FormSubmitted.vue'
import AvailablePosition from '@/pages/AvailablePositionPage.vue'
import CreateAccountPage from '@/pages/CreateAccountPage.vue'
import PaymentProcessing from '@/pages/applicantportal/PaymentProcessing.vue'

/** Admin routes **/
import adminRoutes from '@/admin/routes'    // <-- your new admin module
import ApplicantRoutes from '@/pages/applicantportal/routes' // <-- applicant portal routes
import EmployeeRoutes from '@/pages/employeeportal/routes'  // <-- employee portal routes

/** Route access (roles from login claims) **/
import { auth } from '@/firebase'
import { signOut } from 'firebase/auth'
import { currentClaims, decideAccess, requiresLogin } from '@/router/access'

const routes = [
  // — public —
  { path: '/', name: 'Home', component: HomePage },
  { path: '/apply', name: 'Apply', component: ApplyPage },
  { path: '/about', name: 'About', component: AboutPage },
  { path: '/payment', name: 'Payment', component: PaymentPage },
  { path: '/contact', name: 'Contact', component: ContactPage },
  { path: '/login', name: 'Login', component: LoginPage },
  { path: '/forgot-password', name: 'ForgotPassword', component: ForgotPasswordPage },
  { path: '/submitted', name: 'FormSubmited', component: FormSubmitted },
  { path: '/availablejobs', name: 'AvailablePosition', component: AvailablePosition },
  { path: '/createaccount', name: 'CreateAccount', component: CreateAccountPage },
  { path: '/paymentprocessing', name: 'PaymentProcessing', component: PaymentProcessing },

  // — admin (spread the array from src/admin/routes.js) —
  ...adminRoutes
  // — applicant portal (spread the array from src/pages/applicantportal/routes.js) —
  , ...ApplicantRoutes

  // — employee portal —
  , ...EmployeeRoutes
]

const router = createRouter({
  history: createWebHistory(),
  routes
})

// Global guard: private pages need a login, and the role listed in the route's meta.
// (Data access is enforced separately by firestore.rules; this keeps people off pages they can't use.)
router.beforeEach(async (to) => {
  if (!requiresLogin(to)) return true

  const claims = await currentClaims()
  if (claims && (claims.access === 'blocked' || claims.access === 'removed')) {
    await signOut(auth)
    return { name: 'Login' }
  }
  return decideAccess(to, claims)
})

export default router
